<template>
    <div v-if="isTyping" class="chat-typing-indicator">
        <span class="typing-text">{{ typingText }}</span>
        <span class="typing-dots">
            <span class="dot"></span>
            <span class="dot"></span>
            <span class="dot"></span>
        </span>
    </div>
</template>

<script>
export default {
    name: 'ChatTypingIndicator',
    props: {
        isTyping: {
            type: Boolean,
            default: false
        },
        userName: {
            type: String,
            default: ''
        }
    },
    computed: {
        typingText() {
            if (this.userName) {
                return `${this.userName} est en train d'écrire`;
            }
            return "En train d'écrire";
        }
    }
};
</script>

<style scoped>
.chat-typing-indicator {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 12px;
    color: #6b7280;
    font-size: 13px;
    font-style: italic;
}

.typing-dots {
    display: flex;
    gap: 3px;
}

.dot {
    width: 6px;
    height: 6px;
    background-color: #9ca3af;
    border-radius: 50%;
    animation: typing-bounce 1.4s infinite ease-in-out both;
}

.dot:nth-child(1) {
    animation-delay: -0.32s;
}

.dot:nth-child(2) {
    animation-delay: -0.16s;
}

.dot:nth-child(3) {
    animation-delay: 0s;
}

@keyframes typing-bounce {
    0%, 80%, 100% {
        transform: scale(0.6);
        opacity: 0.5;
    }
    40% {
        transform: scale(1);
        opacity: 1;
    }
}
</style>
